import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PopularAirlinesSharedService {
  translateService = inject(TranslateService);
  preferredAirline: string = '';
  index: number = 0;
  private langIndexSubject = new BehaviorSubject<number>(0);
  langIndex$ = this.langIndexSubject.asObservable();
  constructor(private translate: TranslateService) {
    // Listen to language changes
    this.translate.onLangChange.subscribe((event) => {
      this.updateLangIndex(event.lang);
    });

    // Initialize langIndex with the current language
    this.updateLangIndex(this.translate.currentLang);
  }
  private updateLangIndex(currentLang: string): void {
    const langIndex = currentLang === 'en' ? 0 : currentLang === 'ar' ? 1 : 0;
    this.langIndexSubject.next(langIndex);
  }
  get preferredAirlineIatacode() {
    return this.preferredAirline ? this.preferredAirline : 'all';
  }
}
